import React from 'react';
import { Form } from 'react-bootstrap';

export default function EditSelect({
  value, onChange, data, labelField = 'name', stringValue,
}) {
  return (
    <Form.Control as="select" value={value} onChange={({ target }) => onChange(stringValue ? target.value : parseInt(target.value))}>
      <option value="" />
      {
        data.map((d) => <option key={d.id} value={d.id}>{d[labelField]}</option>)
      }
    </Form.Control>
  );
}
